import {Component, Input, SimpleChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {FieldConfig, FieldConfigOption, FieldConfigType} from 'src/app/model/field-config';
import {AbstractComponent} from '../abstract.component';

@Component({
    selector: 'app-field-config-value-input',
    templateUrl: './field-config-value-input.component.html',
    styleUrls: ['./field-config-value-input.component.scss'],
    standalone: false
})
export class FieldConfigValueInputComponent extends AbstractComponent {
  @Input() inputForm: FormGroup<any> | undefined;
  @Input() fieldKey: string | undefined;
  @Input() fieldConfig: FieldConfig | undefined;

  label: string = ""
  translatedLabels: string[] = [];
  options: Map<number, string> = new Map<number, string>();

  constructor(public translocoService: TranslocoService) {
    super();
  }

  ngOnInit() {
    this.initFields();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fieldConfig']?.currentValue !== changes['fieldConfig']?.previousValue) {
      this.initFields();
    }
  }

  initFields() {
    if (this.fieldConfig) {
      this.label = this.getLabel(this.fieldConfig);
      if (this.fieldConfig.fieldConfigTypeId === FieldConfigType.MULTISELECT) {
        this.options = this.getOptions();
      }
      if (this.fieldConfig.fieldConfigTypeId === FieldConfigType.SELECT) {
        this.translatedLabels = this.getTranslatedLabels();
      }
    }
  }

  getLabel(object: FieldConfig | FieldConfigOption): string {
    const langFieldMap: Record<string, keyof (FieldConfig | FieldConfigOption)> = {
      en: "nameEng",
      hr: "name",
      slo: "nameSlo",
      sr: "nameSr",
      bs: "nameBs",
      it: "nameIta",
    };

    const lang = this.translocoService.getActiveLang();
    const preferredField = langFieldMap[lang];
    const preferredValue = preferredField && (object[preferredField] as string);

    if (preferredValue?.length > 0) return preferredValue;

    // Fall back to any available value
    return Object.values(langFieldMap)
        .map(field => object[field] as string)
        .find(value => value?.length > 0) ?? "";
  }

  getTranslatedLabels(): string[] {
    return this.fieldConfig?.options?.map((item: FieldConfigOption) => this.getLabel(item)) ?? [];
  }

  getOptions(): Map<number, string> {
    const optionsMap = new Map<number, string>();
    this.fieldConfig?.options?.map((option: FieldConfigOption) => {
      if (option.id) {
        optionsMap.set(option.id, this.getLabel(option))
      }
    });
    return optionsMap
  }

  protected readonly FieldConfigType = FieldConfigType;
}
